if (!customElements.get('mbr-home-reviews')) {
  customElements.define('mbr-home-reviews', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.prev || !this.next) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      const move = direction => {
        const card = this.track.querySelector('article');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 20;
        this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.prev.hidden = this.next.hidden = false;
      this.prev.addEventListener('click', () => move(-1), options);
      this.next.addEventListener('click', () => move(1), options);
      this.track.addEventListener('scroll', () => this.update(), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
    }
    disconnectedCallback() {this.abort?.abort(); this.observer?.disconnect();}
  });
}
